export default "__VITE_ASSET__t1rqwNWk__"